<template>
  <div class="settings workorder-settings">
    <h4>Настройка единого отчета</h4>


    <h4>Аналитика по плану</h4>

    <el-radio-group class="menu-settings radio" @change="save" v-model="form.analytics">
      <div
        class="edit-li"
      >
        <el-radio label="without">Без аналитики</el-radio>
      </div>
      <div
        class="edit-li"
      >
        <el-radio label="volume">Физобъемы</el-radio>
      </div>
      <div
        class="edit-li"
      >
        <el-radio label="price"> Стоимость
        </el-radio>
      </div>
      <div
        class="edit-li"
      >
        <el-radio label="progress">Трудоемкость</el-radio>
      </div>
    </el-radio-group>

    <h4>Аналитика по производительности</h4>

    <el-radio-group class="menu-settings radio" @change="save" v-model="form.progressAnalytics">
      <div
        class="edit-li"
      >
        <el-radio label="without">Без аналитики</el-radio>
      </div>
      <div
        class="edit-li"
      >
        <el-radio label="progress">Трудоемкость</el-radio>
      </div>
    </el-radio-group>
    <el-checkbox @change="save" style="margin-top: 32px; margin-left: 16px" v-model="form.profAnalytics">Аналитика по числености</el-checkbox>

    <el-checkbox @change="save" style="margin-top: 32px; margin-left: 16px" v-model="form.autoPlan">Автоматическое добавление суточных планов</el-checkbox>

  </div>
</template>

<script>
import firebase from "firebase";
import dayjs from "dayjs";
import ImportFromExcel from "./ImportFromExcel";

export default {
  name: "Settings",
  components: {ImportFromExcel},
  data() {
    return {
      form: {
        analytics: 'without',
        progressAnalytics: 'without',
        autoPlan: false,
        profAnalytics: false,
      }
    }
  },
  mounted() {
    const {
      reportOne
    } = this.$store.state.project;

    this.form = {
      ...this.form,
      ...reportOne
    };
  },
  methods: {
    save() {
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .update({
          reportOne: {...this.form},
        }).then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Сохранено',
          type: 'success',
        });
        this.$store.dispatch('setProject', {
          reportOne: {...this.form},
        });
      })
        .catch((error) => console.error(error));
    }
  }
}
</script>

<style scoped lang="scss">
.settings {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.menu-settings {
  margin-top: 32px;

  .edit-li {
    display: flex;
    justify-content: space-between;
    height: 40px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    align-items: center;
    padding: 0 10px;
    text-decoration: none;
    color: #000;

    span:first-child {
      margin-right: 20px;
    }

    span {
      margin-right: 5px;
    }

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f5f5f5;
    }
  }

}

.link-cont {
  display: flex;
  justify-content: space-between;
  color: #000;
  text-decoration: none;
  flex: 1;
}

.with-border {
  border-top: 1px solid rgba(0, 0, 0, 0.18);
  margin-top: 10px;
}

</style>
<style lang="scss">
.workorder-settings {
  .edit-li {
    display: flex;
    width: 100%;
    flex: 1;

    .el-radio {
      width: 100%;
      display: flex;
      flex: 1;
      height: 40px;
      align-items: center;
      justify-content: space-between;
      flex-direction: row-reverse;
    }
  }

  .menu-settings.radio {
    display: flex;
    flex: 1;
    width: 100%;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/Settings.vue